/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'ca',
  Pagination: {
    items_per_page: '/ pàgina',
    jump_to: 'Anar a',
    jump_to_confirm: 'Confirma',
    page: '',
    prev_page: 'Pàgina prèvia',
    next_page: 'Pàgina següent',
    prev_5: '5 pàgines prèvies',
    next_5: '5 pàgines següents',
    prev_3: '3 pàgines prèvies',
    next_3: '3 pàgines següents'
  },
  DatePicker: {
    lang: {
      placeholder: 'Seleccionar data',
      rangePlaceholder: ['Data inicial', 'Data final'],
      locale: 'ca_ES',
      today: 'Avui',
      now: 'Ara',
      backToToday: 'Tornar a avui',
      ok: 'Acceptar',
      clear: 'Netejar',
      month: 'Mes',
      year: 'Any',
      timeSelect: 'Seleccionar hora',
      dateSelect: 'Seleccionar data',
      monthSelect: 'Escollir un mes',
      yearSelect: 'Escollir un any',
      decadeSelect: 'Escollir una dècada',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mes anterior (PageUp)',
      nextMonth: 'Mes següent (PageDown)',
      previousYear: 'Any anterior (Control + left)',
      nextYear: 'Mes següent (Control + right)',
      previousDecade: 'Dècada anterior',
      nextDecade: 'Dècada següent',
      previousCentury: 'Segle anterior',
      nextCentury: 'Segle següent'
    },
    timePickerLocale: {
      placeholder: 'Seleccionar hora'
    }
  },
  TimePicker: {
    placeholder: 'Seleccionar hora'
  },
  Calendar: {
    lang: {
      placeholder: 'Seleccionar data',
      rangePlaceholder: ['Data inicial', 'Data final'],
      locale: 'ca_ES',
      today: 'Avui',
      now: 'Ara',
      backToToday: 'Tornar a avui',
      ok: 'Acceptar',
      clear: 'Netejar',
      month: 'Mes',
      year: 'Any',
      timeSelect: 'Seleccionar hora',
      dateSelect: 'Seleccionar data',
      monthSelect: 'Escollir un mes',
      yearSelect: 'Escollir un any',
      decadeSelect: 'Escollir una dècada',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mes anterior (PageUp)',
      nextMonth: 'Mes següent (PageDown)',
      previousYear: 'Any anterior (Control + left)',
      nextYear: 'Mes següent (Control + right)',
      previousDecade: 'Dècada anterior',
      nextDecade: 'Dècada següent',
      previousCentury: 'Segle anterior',
      nextCentury: 'Segle següent'
    },
    timePickerLocale: {
      placeholder: 'Seleccionar hora'
    }
  },
  Table: {
    filterTitle: 'Filtrar Menu',
    filterConfirm: 'OK',
    filterReset: 'Restablir'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel·lar',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancel·lar'
  },
  Transfer: {
    searchPlaceholder: 'Cercar aquí',
    itemUnit: 'item',
    itemsUnit: 'items'
  },
  Upload: {
    uploading: 'Carregant...',
    removeFile: 'Elimina el fitxer',
    uploadError: 'Error de càrrega',
    previewFile: 'Vista prèvia del fitxer',
    downloadFile: "Descarrega l'arxiu"
  },
  Empty: {
    description: 'Sense dades'
  }
};
